import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import AmsRewardsSettingsHtml from './ams-rewards.settings.html';

export function AmsRewardsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'AmsRewardsSettingsCtrl',
    name       : 'app.ams-rewards-settings',
    templateUrl: AmsRewardsSettingsHtml,
    url        : '/ams_rewards_settings',
    resolve    : {
      ams_autoclubs     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/ams_autoclubs'),
      ams_file_frequency: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/ams_file_frequency'),
      integrations      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      session           : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
    }
  });
}